import '../css/app.css';

import 'lazysizes';

import loadComponents from 'gia/loadComponents';
import components from './components';

window.loadComponents = loadComponents;
window.components = components;
loadComponents(components);

import Map from './vue-components/Map.vue';
import NewSecondaryLetter from './vue-components/NewSecondaryLetter.vue';
import { createApp } from 'vue';
import mitt from 'mitt';

const emitter = mitt();

function initVue() {
  if (document.querySelector('#app-map')) {
    console.log('Initializing Map component');
    const app = createApp(Map);
    console.log(app);
    // app.use(pinia);
    app.provide('emitter', emitter);

    app.mount('#app-map');
  }

  if (document.querySelector('#app-new-secondary-letter')) {
    const app = createApp(NewSecondaryLetter);
    console.log(app);
    // app.use(pinia);
    app.provide('emitter', emitter);

    app.mount('#app-new-secondary-letter');
  }
}

// Initialize Vue when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
  initVue();
});
